export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";